module.exports = __webpack_public_path__ + "static/media/logo.705eebb7.png";